import './Landing.scss';

import { useSelector } from 'react-redux';

import { logOut } from 'actions/authentication';
import Button from 'atoms/button';
import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';

export default function Landing({
  children,
  title = 'Connecting you to nearby pet owners',
  text = 'Create your account and start accepting appointments',
}) {
  const { token } = useSelector((state) => state.user);
  const { width } = useWindowDimensions();
  const isMobile = width < 600;

  return (
    <div className="landing">
      <div className="landing-container l-left l-split">
        <div className="landing-container-centered">
          <div className="landing-container-centered-block">
            {!isMobile && <Icon name="pawcare" />}
            <h4 className="strong l-title">{title}</h4>
            <p>{text}</p>
          </div>
        </div>
        {token && (
          <Button
            className="logout no-style-btn c-white f16"
            onClick={() => logOut('/')}
            size="small"
            text="Log out"
            variant="white"
          />
        )}
      </div>
      <div className="l-split l-right">
        <div className="l-centered">{children}</div>
      </div>
    </div>
  );
}
